import styled from 'styled-components';

export const LoadingWrapper = styled('div')`
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  & > img {
    top: 0;
    left: 0;
    right: 0;
    width: 5em;
    bottom: 0;
    margin: auto;
    position: absolute;
  }
`;
